import React from 'react';
import { connect } from 'react-redux';
import { Browser } from './accordion/Browser';
import { SlideViewer } from './slideViewer/SlideViewer';
import { Canvas } from './slide/Canvas';
import { PreviewMenu } from '../components/menus/PreviewMenu';
import { ResizeAccordionButton } from '../components/menus/ResizeAccordionButton';
import { ContextMenu } from '../components/menus/ContextMenu';
import { DeleteAlert } from '../components/menus/DeleteAlert';
import { TextEditor } from '../components/menus/TextEditor';
import { AudioAlert } from '../components/menus/AudioAlert';
import { ExportAlert } from '../components/menus/ExportAlert';
import { ProductTitleAlert } from '../components/menus/ProductTitleAlert';
import { AlternativeTextForSlideMenu } from '../components/menus/AlternativeTextForSlideMenu';
import { DescriptionMenu } from '../components/menus/DescriptionMenu';
import { ExitAlert } from '../components/menus/ExitAlert';
import { MainMenu } from './menus/MainMenu';
import { RecorderPopup } from '../components/menus/RecorderPopup';
import { LostSessionAlert } from '../components/menus/LostSessionAlert';
import { NoInternetConnectionAlert } from '../components/menus/NoInternetConnectionAlert';
import { AppLoader } from './appLoader/AppLoader';
import storeManager from '../store/StoreManager';
import { setWindowSize } from '../actions/ProductionActions';
import { showDescription } from '../actions/MenuActions';
import modeType from '../constants/ModeConstants';
import styles from './App.scss';
import canvasScale from '../components/utils/CanvasScaleUtils';
import { Loader } from './appLoader/Loader';
import { NavigationBar } from '../components/menus/NavigationBar';
import { ZoomMenu } from '../components/menus/ZoomMenu';
import { CroppingMenu } from '../components/menus/CroppingMenu';
import { InternetExplorerAlert } from '../components/menus/InternetExplorerAlert';
import { NoAccessAlert } from '../components/menus/NoAccessAlert';
import { DownloadPage } from '../components/menus/DownloadPage';
import { SearchMenu } from '../components/menus/SearchMenu';
import properties from '../constants/Properties';
import appParameters from '../components/utils/AppParameters';
import platformDetection from '../components/utils/PlatformDetection';
import selectionManager from '../components/utils/SelectionManager';
import groupManager from '../components/utils/GroupManager';
import mouseUtils from '../components/utils/MouseUtils';
import populateMediaFilesUtils from '../components/utils/PopulateMediaFilesUtils';
import exporterUtils from '../components/utils/ExporterUtils';
import slideUtils from './utils/SlidesUtils';
import apiService from '../services/ApiService';
import configuration from '../constants/Configuration';
import audioVolumeUtils from './utils/AudioVolumeUtils';
import apiServiceUtils from './utils/ApiServiceUtils';
import saveManager from './utils/SaveManager';
import textSizeUtils from './utils/TextSizeUtils';
import textEditorUtils from './menus/textEditorTool/utils/TextEditorUtils';

const AppWrapper = React.createClass({
    propTypes: {
        children: React.PropTypes.object,
        appReady: React.PropTypes.bool
    },
    getInitialState() {
        return {
            originalWidth: -1,
            originalHeight: -1
        };
    },
    onScroll(e) {
        e.preventDefault();
        e.stopPropagation();
        window.scrollTo(0, 0);
    },
    onKeyDown(e) {
        if (e.keyCode == 13) // Enter ... used to close the Keyboard on the iPads
            window.scrollTo(0, 0);
    },
    onKeyDownHandler(e) {
        if (platformDetection.isIOS())
            return;

        var isTabPressed = (e.key === 'Tab' || e.keyCode === 9);

        if (!isTabPressed) {
            return;
        }

        var modal;
        var firstFocusableEl;
        var lastFocusableEl;

        modal = document.getElementById('exportPopup');

        if (modal) {
            firstFocusableEl = document.getElementById('exportFirstFocusableCheckBox');

            if (!firstFocusableEl)
                firstFocusableEl = document.getElementById('exportFirstFocusableButton');

            lastFocusableEl = document.getElementById('exportLastFocusableButton');
        }

        modal = document.getElementById('productionInitialTitleAlert');

        if (modal) {
            firstFocusableEl = document.getElementById('productionInitialTitle');
            lastFocusableEl = document.getElementById('productionInitialTitleButton');
        }

        modal = document.getElementById('alternativeTextAlert');

        if (modal) {
            firstFocusableEl = document.getElementById('alternativeTextInput');
            lastFocusableEl = document.getElementById('alternativeTextOkButton');
        }

        modal = document.getElementById('lostSessionAlert');

        if (modal) {
            firstFocusableEl = document.getElementById('lostSessionAlertButton');
            lastFocusableEl = document.getElementById('lostSessionAlertButton');
        }

        modal = document.getElementById('deleteAlert');

        if (modal) {
            firstFocusableEl = document.getElementById('deleteAlertFirstFocusableElement');
            lastFocusableEl = document.getElementById('deleteAlertLastFocusableElement');
        }

        modal = document.getElementById('audioAlert');

        if (modal) {
            firstFocusableEl = document.getElementById('audioAlertFirstFocusableElement');
            lastFocusableEl = document.getElementById('audioAlertLastFocusableElement');
        }

        modal = document.getElementById('textEditorTool');

        if (modal) {
            firstFocusableEl = document.getElementById('firstFocusableObjectForTextEditorTool');
            lastFocusableEl = document.getElementById('lastFocusableObjectForTextEditorTool');
        }

        modal = document.getElementById('recordingPopup');

        if (modal) {
            firstFocusableEl = document.getElementById('recordingFirstFocusableElement');
            lastFocusableEl = document.getElementById('recordingLastFocusableElement');
        }

        modal = document.getElementById('zoomMenu');

        if (modal) {
            firstFocusableEl = document.getElementById('zoomMenuFirstFocusableElement');
            lastFocusableEl = document.getElementById('zoomMenuLastFocusableElement');
        }

        modal = document.getElementById('croppingMenu');

        if (modal) {
            firstFocusableEl = document.getElementById('croppingMenuFirstFocusableElement');
            lastFocusableEl = document.getElementById('croppingMenuLastFocusableElement');
        }

        modal = document.getElementById('leftTextMenu');

        if (modal) {
            firstFocusableEl = document.getElementById('leftTextMenuFirstFocusabletElement');
            lastFocusableEl = document.getElementById('leftTextMenuLastFocusableElement');
        }

        modal = document.getElementById('leftFreehandMenu');

        if (modal) {
            firstFocusableEl = document.getElementById('leftFreehandtMenuFirstFocusabletElement');
            lastFocusableEl = document.getElementById('leftFreehandtMenuLastFocusabletElement');
        }

        modal = document.getElementById('leftShapesMenu');

        if (modal) {
            firstFocusableEl = document.getElementById('leftShapesMenuFirstFocusabletElement');
            lastFocusableEl = document.getElementById('leftShapesMenuLastFocusabletElement');
        }

        modal = document.getElementById('moodsMenu');

        if (modal) {
            firstFocusableEl = document.getElementById('firstFocusableObject');
            lastFocusableEl = document.getElementById('moodsLastItem');
        }

        modal = document.getElementById('mindMapMenu');

        if (modal) {
            firstFocusableEl = document.getElementById('firstFocusableObjectMindMapMenu');
            lastFocusableEl = document.getElementById('mindMapLastItem');
        }

        modal = document.getElementById('rotationFlipMenu');

        if (modal) {
            firstFocusableEl = document.getElementById('rotationFlipFirstItem');
            lastFocusableEl = document.getElementById('rotationFlipLastItem');
        }

        modal = document.getElementById('sizeAndPositionMenu');

        if (modal) {
            firstFocusableEl = document.getElementById('resizeFirstItem');
            lastFocusableEl = document.getElementById('resizeLastItem');
        }

        modal = document.getElementById('saveMenu');

        if (modal) {
            firstFocusableEl = document.getElementById('firstFocusableObject');
            lastFocusableEl = document.getElementById('saveMenuLastFocusableElement');
        }

        modal = document.getElementById('textStylingMenu');

        if (modal) {
            firstFocusableEl = document.getElementById('firstFocusableObjectForTextStylingMenu');
            lastFocusableEl = document.getElementById('textStylingMenuLastFocusableElement');
        }

        modal = document.getElementById('stylingMenu');

        if (modal) {
            firstFocusableEl = document.getElementById('firstFocusableObjectForStylingMenu');
            lastFocusableEl = document.getElementById('stylingMenuLastFocusableElement');
        }

        modal = document.getElementById('backgroundVisibilityMenu');

        if (modal) {
            firstFocusableEl = document.getElementById('firstFocusableObjectForBackgroundVisibilityMenu');
            lastFocusableEl = document.getElementById('lastFocusableObjectForBackgroundVisibilityMenu');
        }

        modal = document.getElementById('animationMenu');

        if (modal) {
            firstFocusableEl = document.getElementById('animationFirstFocusableObject');
            lastFocusableEl = document.getElementById('animationMenuLastFocusableObject');
        }

        modal = document.getElementById('objectContextMenu');

        if (modal) {
            firstFocusableEl = document.getElementById('firstFocusableObjectFromMoreMenu');
            lastFocusableEl = document.getElementById('objectContextLastFocusableElement');
        }

        modal = document.getElementById('drawingMenu');

        if (modal) {
            firstFocusableEl = document.getElementById('firstFocusableElement');
            lastFocusableEl = document.getElementById('drawingFreehandLastFocusableElement');
        }

        if (!firstFocusableEl || !lastFocusableEl)
            return;

        if (e.shiftKey) /* shift + tab */ {
            if (document.activeElement === firstFocusableEl) {
                lastFocusableEl.focus();
                e.preventDefault();
            }
        } else /* tab */ {
            if (document.activeElement === lastFocusableEl) {
                firstFocusableEl.focus();
                e.preventDefault();
            }
        }
    },
    onMouseDown() {
        slideUtils.updateAllThumbnails = false;
    },
    onUnload() {
        if (configuration.LOAD_LOCAL)
            return;

        if (appParameters.submitId > 0) {
            apiService.unlockProduction(appParameters.submitId);
        }
    },
    componentDidMount() {
        audioVolumeUtils.addEventListener();
        window.addEventListener('beforeunload', this.onUnload);

        if (platformDetection.isIOS() == true) {
            window.addEventListener('resize', this.onResizeApp);
            window.addEventListener('touchstart', this.onMouseDown);

            window.addEventListener('blur', this.onScroll);
            window.addEventListener('focusout', this.onScroll);
            document.addEventListener('keydown', this.onKeyDown);
        } else {
            window.addEventListener('resize', this.onResize);
            window.addEventListener('mousedown', this.onMouseDown);
            document.addEventListener('keydown', this.onKeyDownHandler);
        }

        const { dispatch } = this.props;
        dispatch(setWindowSize(window.innerWidth, window.innerHeight));

        selectionManager.dispatch = dispatch;
        groupManager.dispatch = dispatch;

        this.setState({
            originalWidth: window.innerWidth,
            originalHeight: window.innerHeight
        });
    },
    componentWillUnmount() {
        audioVolumeUtils.removeEventListener();
        window.removeEventListener('beforeunload', this.onUnload);

        if (platformDetection.isIOS() == true) {
            window.removeEventListener('resize', this.onResizeApp);
            window.removeEventListener('touchstart', this.onMouseDown);

            window.removeEventListener('blur', this.onScroll);
            window.removeEventListener('focusout', this.onScroll);
            document.removeEventListener('keydown', this.onKeyDown);
        } else {
            window.removeEventListener('resize', this.onResize);
            window.removeEventListener('mousedown', this.onMouseDown);
            document.removeEventListener('keydown', this.onKeyDownHandler);
        }

        populateMediaFilesUtils.cleanTimers();
        exporterUtils.removeEvent();
    },
    onResizeApp() {
        if (platformDetection.isIOS() && window.navigator.userAgent.match('CriOS')) { // is Chrome on IOS
            setTimeout(function() {
                parent.location.reload();
            }.bind(this), 100);

            return;
        }

        if (this.state.originalWidth && this.state.originalHeight) {
            if ((this.state.originalWidth > this.state.originalHeight && window.innerWidth < window.innerHeight) || (this.state.originalWidth < this.state.originalHeight && window.innerWidth > window.innerHeight)) {
                saveManager.saveData();

                this.setState({
                    originalWidth: window.innerWidth,
                    originalHeight: window.innerHeight
                });

                setTimeout(this.onResize, 100);
            }
        }
    },
    onResize() {
        this.refreshView();
    },
    refreshView () {
        const { dispatch } = this.props;

        if (platformDetection.isIOS() == true) {
            if (window.innerWidth > window.innerHeight)
                dispatch(setWindowSize(this.state.originalWidth, this.state.originalHeight));
            else
                dispatch(setWindowSize(window.innerWidth, window.innerHeight));

            setTimeout(this.updateView, 20);
        } else {
            dispatch(setWindowSize(window.innerWidth, window.innerHeight));

            setTimeout(this.updateView, 20);
        }
    },
    updateView() {
        this.forceUpdate();
    },
    onAppMouseDown(e) {
        textEditorUtils.checkTextSelection(e);
    },
    onAppClick(e) {
        if (textSizeUtils.isTextEditMode())
            return;

        if (!platformDetection.isIOSApp())
            return;

        if (mouseUtils.rejectMouseEvent(e))
            return;

        const store = storeManager.getStore();
        const state = storeManager.getState();
        const showDescriptionValue = state.menu.showDescription;

        if (showDescriptionValue && e.target.className != 'describeItem' && e.target.className != 'fa fa-eye')
            store.dispatch(showDescription(false));

    },
    render () {
        if (platformDetection.isIE() == true) {
            if (this.props.captionsLoaded == true)
                return <InternetExplorerAlert windowWidth={this.props.windowWidth} windowHeight={this.props.windowHeight}/>;
            else
                return <AppLoader />;
        }

        if (this.props.captionsLoaded && appParameters.context == modeType.DOWNLOAD)
            return (<DownloadPage windowWidth={this.props.windowWidth} windowHeight={this.props.windowHeight}/>);

        if (this.props.hasNotAccess == true) {
            if (this.props.captionsLoaded == true)
                return <NoAccessAlert windowWidth={this.props.windowWidth} windowHeight={this.props.windowHeight}/>;
            else
                return <AppLoader />;
        }

        if (!this.props.appReady) {
            return <AppLoader />;
        }

        const appStyle = {
            width: this.props.windowWidth,
            height: this.props.windowHeight,
            background: '#F2F2F2',
            overflow: 'hidden',
            position: 'absolute',
            top: 0
        };

        var mode = this.props.mode;

        if (this.props.showVideoEditor)
            mode = modeType.VIDEO_EDITOR;
        else if (mode != modeType.PLAYER && mode != modeType.PREVIEW && this.props.showAudioEditor)
            mode = modeType.AUDIO_EDITOR;

        const tooltipStyle = {
            position: 'absolute',
            top: 0,
            left: this.props.windowWidth - this.props.accordionWidth
        };

        var noInternetAlertHeight = apiServiceUtils.getNoInternetConnectionAlertHeight();
        const scaleProperties = canvasScale.getScaleProperties(this.props.windowWidth, this.props.windowHeight, this.props.accordionWidth, mode);
        var elements = [];

        if (appParameters.getMode() == modeType.PLAYER || this.props.showVideoEditor) {
            if (!this.props.showVideoEditor) // is PLAYER
                elements.push(<PreviewMenu dispatch={this.props.dispatch} scaleProperties={scaleProperties} key={'appElement0'}/>);
            else { // is VIDEO EDITOR MODE
                elements.push(<Browser dispatch={this.props.dispatch} windowWidth={this.props.windowWidth} windowHeight={this.props.windowHeight} showVideoEditor={this.props.showVideoEditor} noInternetAlertHeight={noInternetAlertHeight} key={'appElement1'}/>);
                elements.push(<SearchMenu dispatch={this.props.dispatch} windowWidth={this.props.windowWidth} windowHeight={this.props.windowHeight - noInternetAlertHeight} key={'appElement31'}/>);
                elements.push(<SlideViewer dispatch={this.props.dispatch} windowWidth={this.props.windowWidth} windowHeight={this.props.windowHeight} showVideoEditor={this.props.showVideoEditor} key={'appElement2'}/>);
                elements.push(<ContextMenu dispatch={this.props.dispatch} windowWidth={this.props.windowWidth} windowHeight={this.props.windowHeight - noInternetAlertHeight} key={'appElement3'}/>);
                elements.push(<AudioAlert dispatch={this.props.dispatch} windowWidth={this.props.windowWidth} windowHeight={this.props.windowHeight - noInternetAlertHeight} key={'appElement14'}/>);
                elements.push( <div id='toolTipHolder' key={'appElement17'} style={tooltipStyle}/>);
            }
        } else { // EDITOR or PREVIEW mode
            var extraHeight = 0;

            if (platformDetection.isIOSApp()) {
                extraHeight = properties.CLIPART_BUTTON_HEIGHT_OLD;
                elements.push(<NavigationBar key={'appElement10'} windowWidth={this.props.windowWidth}/>);
            }

            extraHeight = extraHeight + noInternetAlertHeight;

            if (this.props.mode == modeType.EDITOR) { // EDITOR regular mode
                if (platformDetection.isIOS() == false || this.props.showAudioEditor)
                    elements.push(<ResizeAccordionButton dispatch={this.props.dispatch} timelines={this.props.timelines} accordionWidth={this.props.accordionWidth} windowWidth={this.props.windowWidth} windowHeight={this.props.windowHeight} showAudioEditor={this.props.showAudioEditor} key={'appElement0'}/>);

                elements.push(<MainMenu dispatch={this.props.dispatch} windowWidth={this.props.windowWidth} windowHeight={this.props.windowHeight} noInternetAlertHeight={noInternetAlertHeight} key={'appElement00'}/>);
                elements.push(<SearchMenu dispatch={this.props.dispatch} windowWidth={this.props.windowWidth} windowHeight={this.props.windowHeight - noInternetAlertHeight} key={'appElement31'}/>);
                elements.push(<Browser dispatch={this.props.dispatch} windowWidth={this.props.windowWidth} windowHeight={this.props.windowHeight} noInternetAlertHeight={noInternetAlertHeight} key={'appElement1'}/>);
                elements.push(<SlideViewer dispatch={this.props.dispatch} windowWidth={this.props.windowWidth} windowHeight={this.props.windowHeight} showVideoEditor={this.props.showVideoEditor} key={'appElement2'}/>);
                elements.push(<ContextMenu dispatch={this.props.dispatch} windowWidth={this.props.windowWidth} windowHeight={this.props.windowHeight - noInternetAlertHeight} key={'appElement3'}/>);
                elements.push(<ZoomMenu dispatch={this.props.dispatch} accordionWidth={this.props.accordionWidth} windowHeight={this.props.windowHeight - noInternetAlertHeight} key={'appElement8'}/>);
                elements.push(<CroppingMenu dispatch={this.props.dispatch} accordionWidth={this.props.accordionWidth} windowHeight={this.props.windowHeight - noInternetAlertHeight} key={'appElement28'}/>);
                elements.push(<DeleteAlert dispatch={this.props.dispatch} windowWidth={this.props.windowWidth} windowHeight={this.props.windowHeight - noInternetAlertHeight} key={'appElement5'}/>);
                elements.push(<AudioAlert dispatch={this.props.dispatch} windowWidth={this.props.windowWidth} windowHeight={this.props.windowHeight - noInternetAlertHeight} key={'appElement14'}/>);
                elements.push(<ExportAlert dispatch={this.props.dispatch} windowWidth={this.props.windowWidth} windowHeight={this.props.windowHeight - noInternetAlertHeight} key={'appElement13'}/>);
                elements.push(<ProductTitleAlert dispatch={this.props.dispatch} windowWidth={this.props.windowWidth} windowHeight={this.props.windowHeight - noInternetAlertHeight} key={'appElement15'}/>);
                elements.push(<AlternativeTextForSlideMenu dispatch={this.props.dispatch} windowWidth={this.props.windowWidth} windowHeight={this.props.windowHeight - noInternetAlertHeight} key={'appElement40'}/>);
                elements.push(<RecorderPopup windowWidth={this.props.windowWidth} windowHeight={this.props.windowHeight - noInternetAlertHeight} key={'appElement20'}/>);
                elements.push(<LostSessionAlert windowWidth={this.props.windowWidth} windowHeight={this.props.windowHeight - noInternetAlertHeight} key={'appElement6'}/>);
                elements.push(<NoInternetConnectionAlert windowWidth={this.props.windowWidth} windowHeight={this.props.windowHeight - noInternetAlertHeight} key={'appElement18'}/>);
                elements.push(<Loader windowWidth={this.props.windowWidth} windowHeight={this.props.windowHeight - extraHeight} key={'appElement7'}/>);
                elements.push( <div id='toolTipHolder' key={'appElement17'} style={tooltipStyle}/>);

                if (platformDetection.isIOS())
                    elements.push(<TextEditor dispatch={this.props.dispatch} windowWidth={this.props.windowWidth} windowHeight={this.props.windowHeight - noInternetAlertHeight} key={'appElement21'}/>);
            } else { // PREVIEW mode
                elements.push(<PreviewMenu dispatch={this.props.dispatch} scaleProperties={scaleProperties} key={'appElement0'}/>);
                elements.push(<Loader windowWidth={this.props.windowWidth} windowHeight={this.props.windowHeight - noInternetAlertHeight} key={'appElement7'}/>);
            }

            if (platformDetection.isIOSApp()) {
                elements.push(<DescriptionMenu key={'appElement11'} windowWidth={this.props.windowWidth}/>);
                elements.push(<ExitAlert key={'appElement12'} windowWidth={this.props.windowWidth} windowHeight={this.props.windowHeight - noInternetAlertHeight}/>);
            }
        }

        return (
            <div id='app' style={appStyle} className={styles.app} onTouchEnd={this.onAppClick} onClick={this.onAppClick} onTouchStart={this.onAppMouseDown} onMouseDown={this.onAppMouseDown}>
                <Canvas mode={this.props.mode} scaleProperties={scaleProperties} showVideoEditor={this.props.showVideoEditor} dispatch={this.props.dispatch} accordionWidth={this.props.accordionWidth} windowWidth={this.props.windowWidth} windowHeight={this.props.windowHeight - noInternetAlertHeight}/>
                {elements}
            </div>
        );
    }
});

function mapStateToProps () {
    const state = storeManager.getState();
    const store = storeManager.getStore();
    const mode = state.production.mode;
    let windowWidth = state.production.windowWidth;
    let windowHeight = state.production.windowHeight;
    var accordionWidth = state.accordion.width;
    var hasNotAccess = state.menu.hasNotAccess;
    var showVideoEditor = state.menu.showVideoEditor;
    var showAudioEditor = state.menu.showAudioEditor;
    const timelines = state.audioEditor.timelines;
    var showLostSessionAlert = state.menu.showLostSessionAlert;

    if (!(windowWidth > 0))
        windowWidth = window.innerWidth;

    if (!(windowHeight > 0))
        windowHeight = window.innerHeight;

    if (accordionWidth == undefined)
        accordionWidth = properties.BROWSER_WIDTH;

    if (!hasNotAccess)
        hasNotAccess = false;

    if (!showVideoEditor)
        showVideoEditor = false;

    if (showAudioEditor == undefined)
        showAudioEditor = false;

    return {
        appReady: state.session.appReady && state.session.captionsLoaded,
        dispatch: store.dispatch,
        captionsLoaded: state.session.captionsLoaded,
        accordionWidth,
        windowWidth,
        windowHeight,
        mode,
        hasNotAccess,
        showVideoEditor,
        showAudioEditor,
        timelines,
        showLostSessionAlert
    };
}

export const App = connect(mapStateToProps)(AppWrapper);


/** WEBPACK FOOTER **
 ** ./src/components/App.js
 **/